import apiSlice from './apiSlice';

export interface CreateNotificationRequest {
  title: string;
  message: string;
  link: string;
  notificationCode?: string;
}

export interface INotificationItem {
  id: number;
  notificationCode: string;
  title: string;
  message: string;
  link: string | null;
  type: string;
  isGlobal: boolean;
  data: Record<string, any>;
  createdAt: string;
  totalRecipients: number;
  totalRead: number;
  totalUnread: number;
}

export interface INotificationsResponse {
  count: number;
  skip: number;
  take: number;
  fromDate: string | null;
  toDate: string | null;
  data: INotificationItem[];
}

export interface INotificationsRequestParams {
  skip?: number;
  take?: number;
  search?: string;
  fromDate?: string;
  toDate?: string;
  notificationCode?: string;
}
export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createNotification: builder.mutation<void, CreateNotificationRequest>({
      query: (data) => ({
        url: '/notifications',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Notifications'],
    }),
    getNotification: builder.query<INotificationsResponse, INotificationsRequestParams>({
      query: (params) => ({
        url: '/notifications/admin',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useCreateNotificationMutation, useGetNotificationQuery } = notificationApi;
